import axios from 'axios';
import Session from 'supertokens-web-js/recipe/session';
import {
    CreateListingRequest,
    UpdateListingRequest,
    ListingSearchCriteria,
    Listing,
    SearchResult, ListingStatus, UserListingResult, UserListingSearchCriteria
} from '@/models/backend/ListingModels';
import {ListingApiEndpoint} from "@/beepallet.consts";
import {transformToFrontendListing} from "@/transformers/ListingTransformer";
import {SearchRequest} from "@/models/backend/SearchResult";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import store from '@/store'; // Import store directly as a module



export async function getDistance(id: string, postalCode: string): Promise<number> {
    try {
        const response = await axios.get(`${ListingApiEndpoint}/api/listing/distance/${id}/${postalCode}`, {
            withCredentials: true
        });
        return response.data.distanceInKm;
    } catch (error) {
        console.error('Error fetching distance:', error);
        throw new Error("Error en el código postal");
    }
}


export async function createListing(data: CreateListingRequest): Promise<Listing> {
    await Session.attemptRefreshingSession();

    try {
        const response = await axios.post(`${ListingApiEndpoint}/api/listing`, data, {
            withCredentials: true,
            headers: { "Content-Type": "application/json" }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating listing:', error);
        throw error;
    }
}

export async function updateListing(data: UpdateListingRequest): Promise<Listing> {
    await Session.attemptRefreshingSession();

    try {
        const response = await axios.put(`${ListingApiEndpoint}/api/listing`, data, {
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error updating listing:', error);
        throw error;
    }
}

export async function closeListing(listingId : string) : Promise<void> {
    await Session.attemptRefreshingSession();

    try {

        await axios.put(`${ListingApiEndpoint}/api/listing/status`, {
            id: listingId,
            status: ListingStatus.CLOSED
        }, {
            withCredentials: true,
        });
        LocalStorageService.clearBidKeys();
        await   store.dispatch('notifications/fetchNotificationCounts');


    } catch (error) {
        console.error('Error closing listing:', error);
        throw error;
    }
}

export async function getListing(id: string): Promise<Listing> {


    try {
        const response = await axios.get(`${ListingApiEndpoint}/api/listing/${id}`);
        return await transformToFrontendListing(response.data);
    } catch (error) {
        console.error('Error fetching listing:', error);
        throw error;
    }
}

export async function getUserListings(request : UserListingSearchCriteria) : Promise<SearchResult<UserListingResult>> {
    await Session.attemptRefreshingSession();

    try {
        const response = await axios.get(`${ListingApiEndpoint}/api/listings/search/user`, {
            withCredentials: true,
            params: request
        });
        const result = {
            ...response.data,
            results: response.data.results.map((r : any) => {
                return {
                    ...r,
                    listing: {
                        ...r.listing,
                        featureValues: r.listing.listingFeatureValues.map((feature: any) => ({
                           ...feature,
                           featureValues: feature.featureValues.map((value: any) => value.value)
                        }))
                    }
                }
            })
        }


        return result;
    } catch (error) {
        console.error('Error fetching user listings:', error);
        throw error;
    }
}


export async function getPendingBidsCountFromListings(type: string | null): Promise<number> {
    await Session.attemptRefreshingSession();
    const typeKey = type ? type : 'ALL';
    const cacheKey = 'listing_pending_bids_' + typeKey;

    const totalInCache = LocalStorageService
        .getItemWithExpiration<{total: number}>(cacheKey);
    if(totalInCache) return totalInCache.total;
    try {
        const response = await axios.get(`${ListingApiEndpoint}/api/listing/counters/pending_bids`, {
            withCredentials: true,
            params: {type}
        });

        LocalStorageService.saveItemWithExpiration(cacheKey, response.data, 2);

        return response.data.total;
    } catch (error) {
        console.error('Error fetching pending bids count:', error);
        throw error;
    }
}


export async function searchListings(criteria: ListingSearchCriteria): Promise<SearchResult<Listing>> {


    try {
        const response = await axios.get(`${ListingApiEndpoint}/api/listings/search`, {
            params: criteria,
        });
        return response.data;
    } catch (error) {
        console.error('Error searching listings:', error);
        throw error;
    }
}
